// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2mKO1","spin":"styles_spin__1HUvH","inner":"styles_inner__1ctUc"};